var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dl',{staticClass:"m-0 p-0 flex flex-column post-causes-tags leading-normal"},[_c('dt',{staticClass:"inline-block mr-2"},[_vm._v(_vm._s(_vm.title)+":")]),_c('dd',{staticClass:"inline-block"},[_vm._v(" "+_vm._s(_vm.tagsList)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }